import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import { Provider } from 'react-redux';
import moment from 'moment';
import smoothScroll from 'smoothscroll-polyfill';
import { store } from './stores/store';
import App from './components/App';
import 'moment/locale/ru';
import * as serviceWorker from './serviceWorker';

smoothScroll.polyfill();
moment.locale('ru');

const renderApp = (): void => {
  ReactDOM.render(
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>,
    document.getElementById('root')
  );
};

const ieDetection = (): void => {
  const ua = navigator.userAgent;
  const is_ie = ua.indexOf('MSIE') > -1 || ua.indexOf('Trident/') > -1;
  
  if (is_ie){
    const messageBlock = document.querySelector('.ie-detection') as HTMLElement;
    if (messageBlock) {
      messageBlock.style.display = 'flex';
    }
  }else{
    renderApp();
  }

}

ieDetection();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register();
serviceWorker.unregister();
